

export const fixCommaFloatingPointNumber = number => {
  if (number === 0) return 0
  let parsed = number ? parseFloat((number + "").replace(/,/, ".")) : null
  if (isNaN(parsed)) parsed = number
  return parsed
}


export default (integers = []) => {
  return {
    data() {
      return {
        ...integers.reduce((obj, key) => ({
          ...obj,
          [key]: 0,
        }), {})
      }
    },
    methods: {
      fixComma: fixCommaFloatingPointNumber,
    },
    computed: {
      getFixedFloatingNumber() {
        return integers.reduce((obj, key) => {
          return ({
            ...obj,
            [key]: this.fixComma((this.$v && this.$v[key]) ? this.$v[key].$model : this[key]),
          })
        }, {})
      },
    },
  }
}
